import React from 'react';
import { InfoSection } from '../../Components';
import { homeObjThree } from './Data';

function SignUp() {
  return (
    <>
      <InfoSection {...homeObjThree} />
    </>
  );
}

export default SignUp;
